import type { RouteLocationNormalized, Router } from 'vue-router'
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { registerSessionEndedHandler } from '@/@vxapp/Auth/sessionEnded'
import { captureAuthReturnRoute } from '@/plugins/2.router/authReturnRoute'

interface SessionEndedAuthStore {
  pageMeta: unknown
  // eslint-disable-next-line no-unused-vars -- Function-type parameter names are not bindings.
  setPageMeta: (route: unknown, whoCalledMe: string, force?: boolean) => unknown
}

const authRouteNames = new Set<unknown>(
  Object.values(PageMeta.Auth).map(authRoute => authRoute.name)
)

/**
 * Registers the router-aware half of the Stores session-ended pathway: save the user's
 * current page for the same owner, then open sign-in once.
 */
export function installSessionEndedNavigation(
  router: Router,
  getAuthStore: () => SessionEndedAuthStore
): void {
  let pending: Promise<void> | null = null

  registerSessionEndedHandler((_reason, { owner }) => {
    pending ??= (async () => {
      const authStore = getAuthStore()
      const current = router.currentRoute.value as RouteLocationNormalized
      const isAuthPage = authRouteNames.has(current.name)

      if (!(isAuthPage && authStore.pageMeta)) {
        const returnRoute = captureAuthReturnRoute(current, { owner })

        if (returnRoute) authStore.setPageMeta(returnRoute, 'Session ended', true)
      }

      if (current.name !== PageMeta.Auth.login.name)
        await router.push({ name: PageMeta.Auth.login.name as 'login' })
    })().finally(() => {
      pending = null
    })

    return pending
  })
}
